module.exports = __webpack_public_path__ + "img/cancel@2x.4b9ffaf7.png";